import { BaseLayoutFactory } from '../../../components/base-layout-factory';
import CreateEditAmendment from './amendment-create-edit';
import { AmendmentCreateEditProvider } from './context/amendment-create-edit-context';

export function AmendmentCreateEditFactory() {
    return (
        <BaseLayoutFactory>
            <AmendmentCreateEditProvider>
                <CreateEditAmendment />
            </AmendmentCreateEditProvider>
        </BaseLayoutFactory>
    );
}
